import React from "react";
import { useIntl } from "react-intl";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import NotFound from "./components/NotFound";
import { OnetrackProvider as BaseOnetrackProvider } from "./components/Onetrack/context";
import Contact from "./pages/Contact";
import Faq from "./pages/Faq";
import Home from "./pages/Home";
import Service from "./pages/Service";
import { I18nProvider, useLocale } from "./utils/i18n";

function DocumentTitle() {
  const intl = useIntl();
  const title = intl.formatMessage({ id: "Mi.Privacy.Support" });
  React.useEffect(() => {
    document.title = title;
  }, [title]);
  return null;
}

const OnetrackProvider: React.FC = ({ children }) => {
  const [locale] = useLocale();
  return (
    <BaseOnetrackProvider
      params={() => {
        const searchParams = new URLSearchParams(window.location.search);
        return {
          utm_source: searchParams.get("utm_source"),
          locale,
        };
      }}
    >
      {children}
    </BaseOnetrackProvider>
  );
};

function App() {
  return (
    <BrowserRouter basename="/support">
      <I18nProvider>
        <DocumentTitle />
        <OnetrackProvider>
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/contact">
              <Contact />
            </Route>
            <Route path="/faq">
              <Faq />
            </Route>
            <Route path="/service">
              <Service />
            </Route>
            <Route path="/">
              <NotFound />
            </Route>
          </Switch>
        </OnetrackProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}

export default App;
